import axios from 'axios';
import config from '../config';

export default axios.create({
  baseURL:
    config[process.env.REACT_APP_ENVIRONMENT]?.apiUrl || config.default.apiUrl,
  // proxy: config[process.env.REACT_APP_ENVIRONMENT]?.apiUrl || config.default.apiUrl,
});
